import { TextArea } from "components/TextArea";
import styled from "styled-components/macro";

export const MessageTextArea = styled(TextArea)`
  width: 100%;
  min-height: 8rem;
`;
